import axios from 'axios';

const actions = {
}

export default actions;
